import { normalizeRole } from '@/shared/role'
import { http } from '@/shared/api/http'
import { useAuthStore } from '@/shared/store/authStore'
import type { LoginResponse, User } from '@/features/auth/types'

export interface LoginInput {
  corpCd: string
  userId: string
  password: string
}

export async function login(input: LoginInput): Promise<LoginResponse> {
  return http.post<LoginResponse, LoginInput>('/api/auth/login', input, { needAuth: false })
}

export async function fetchMe(): Promise<User> {
  const raw = await http.get<User>('/api/auth/me')
  const user: User = { ...raw, role: normalizeRole(raw.userAuthTp ?? raw.role) }
  useAuthStore.getState().setUser(user)
  return user
}

export async function changePassword(body: {
  oldPassword: string
  newPassword: string
}): Promise<{ success: boolean; message: string }> {
  return http.post('/api/auth/change-password', body)
}
